import { render } from "./RewardIcon.vue?vue&type=template&id=320b5878"
import script from "./RewardIcon.vue?vue&type=script&lang=js"
export * from "./RewardIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__